// Generated by `bazel run i18n`. Do not edit by hand.
import home_48172dae from "./en/account--app--src--account--home.json";
import lists_05f113fc from "./en/account--app--src--account--lists.json";
import orders_ef59f554 from "./en/account--app--src--account--orders.json";
import personalInfo_7315117f from "./en/account--app--src--account--personal-info.json";
import warranties_0301789d from "./en/account--app--src--account--warranties.json";
import account_afe6dd13 from "./en/account--app--src--account.json";
import login_fc31d166 from "./en/account--app--src--login.json";
import oms_3534c786 from "./en/orders--app--src--oms.json";
import hooks_5b245a30 from "./en/orders--app--src--order--hooks.json";
import fulfillment_90b045d2 from "./en/orders--app--src--order--order-tracking--fulfillment.json";
import orderTrackingIframes_8301af3a from "./en/orders--app--src--order-tracking-iframes.json";
import order_849bf5b9 from "./en/orders--app--src--order.json";
import chooseRecipient_9fec3697 from "./en/orders--app--src--orders--gift-receipts--create-gift-receipt--choose-recipient.json";
import dispatcher_1258d860 from "./en/orders--app--src--orders--gift-receipts--create-gift-receipt--dispatcher.json";
import selectItems_3a8ee42e from "./en/orders--app--src--orders--gift-receipts--create-gift-receipt--select-items.json";
import share_d2b86d88 from "./en/orders--app--src--orders--gift-receipts--details--share.json";
import details_09c4f89f from "./en/orders--app--src--orders--gift-receipts--details.json";
import manage_fbbea634 from "./en/orders--app--src--orders--gift-receipts--manage.json";
import giftReceipts_478648bf from "./en/orders--app--src--orders--gift-receipts.json";
import hooks_4eace719 from "./en/orders--app--src--orders--hooks.json";
import screens_9b3ebcec from "./en/orders--app--src--orders--hsa-reimburse--screens.json";
import hsaReimburse_3749186e from "./en/orders--app--src--orders--hsa-reimburse.json";
import orderDetails_f2631021 from "./en/orders--app--src--orders--order-details.json";
import returnMethod_ec757f2e from "./en/orders--app--src--orders--return-method.json";
import orders_a86775a3 from "./en/orders--app--src--orders.json";
import additionalClaimDocuments_64d9d05d from "./en/returns--app--src--returns--additional-claim-documents.json";
import dropoffs_43ce26e5 from "./en/returns--app--src--returns--components--dropoffs.json";
import components_baad9e43 from "./en/returns--app--src--returns--components.json";
import confirmationDisplay_9073d467 from "./en/returns--app--src--returns--confirmation-display.json";
import exchangeConversion_31b5d151 from "./en/returns--app--src--returns--exchange-conversion.json";
import returns_0ccce345 from "./en/returns--app--src--returns.json";
import cart_921edd15 from "./en/returns--app--src--submission--components--cart.json";
import media_9a207fdd from "./en/returns--app--src--submission--components--product-configurator--media.json";
import productOptions_176a883a from "./en/returns--app--src--submission--components--product-configurator--product-options.json";
import productConfigurator_b4bd8934 from "./en/returns--app--src--submission--components--product-configurator.json";
import variantPicker_c8533f48 from "./en/returns--app--src--submission--components--variant-picker.json";
import components_c8f7dbfc from "./en/returns--app--src--submission--components.json";
import hooks_d951004c from "./en/returns--app--src--submission--hooks.json";
import cart_fe19976f from "./en/returns--app--src--submission--screens--cart.json";
import addExchangeItem_0aa6c2ac from "./en/returns--app--src--submission--screens--choose-compensation-method--add-exchange-item.json";
import chooseCompensationMethod_f6a99f24 from "./en/returns--app--src--submission--screens--choose-compensation-method.json";
import claimDocumentsReturn_a4b2393e from "./en/returns--app--src--submission--screens--claim-documents-return.json";
import flowInput_5efb1ad4 from "./en/returns--app--src--submission--screens--flow-input.json";
import flowReturn_eb195764 from "./en/returns--app--src--submission--screens--flow-return.json";
import flow_11080d18 from "./en/returns--app--src--submission--screens--flow.json";
import itemDetails_131c1845 from "./en/returns--app--src--submission--screens--item-details.json";
import login_38c568be from "./en/returns--app--src--submission--screens--login.json";
import merchantFlow_dee61aed from "./en/returns--app--src--submission--screens--merchant-flow.json";
import packagePickup_30db431b from "./en/returns--app--src--submission--screens--package-pickup.json";
import review_7d61328e from "./en/returns--app--src--submission--screens--review.json";
import selectItems_b3b7a91e from "./en/returns--app--src--submission--screens--select-items.json";
import shipmentMethod_3d0a4272 from "./en/returns--app--src--submission--screens--shipment-method.json";
import shopNow_7cf8081c from "./en/returns--app--src--submission--screens--shop-now.json";
import withdrawalReview_c96d1332 from "./en/returns--app--src--submission--screens--withdrawal-review.json";
import submission_b88e3dfc from "./en/returns--app--src--submission.json";
import actionAuthorize_4abc4675 from "./en/src--action-authorize.json";
import csat_d29dc12e from "./en/src--csat.json";
import customization_1da3bcec from "./en/src--customization.json";
import list_8fd75d5d from "./en/src--list.json";
import login_16c6e00f from "./en/src--login.json";
import merchantOverrides_a2188522 from "./en/src--portal-four--shared-components--merchant-overrides.json";
import sharedComponents_522eec4e from "./en/src--portal-four--shared-components.json";
import util_d059057b from "./en/src--util.json";
import components_e16f89f8 from "./en/warranties--app--src--register--components.json";
import hooks_631c1a95 from "./en/warranties--app--src--register--hooks.json";
import screens_5c95bcfc from "./en/warranties--app--src--register--screens.json";
import register_7b902d88 from "./en/warranties--app--src--register.json";
import thirdPartyWarranty_def7b5df from "./en/warranties--app--src--third-party-warranty.json";
import policies_2263052d from "./en/warranties--app--src--warranties--policies.json";
import warranties_45249157 from "./en/warranties--app--src--warranties.json";

export default Object.assign(
  {},
  home_48172dae,
  lists_05f113fc,
  orders_ef59f554,
  personalInfo_7315117f,
  warranties_0301789d,
  account_afe6dd13,
  login_fc31d166,
  oms_3534c786,
  hooks_5b245a30,
  fulfillment_90b045d2,
  orderTrackingIframes_8301af3a,
  order_849bf5b9,
  chooseRecipient_9fec3697,
  dispatcher_1258d860,
  selectItems_3a8ee42e,
  share_d2b86d88,
  details_09c4f89f,
  manage_fbbea634,
  giftReceipts_478648bf,
  hooks_4eace719,
  screens_9b3ebcec,
  hsaReimburse_3749186e,
  orderDetails_f2631021,
  returnMethod_ec757f2e,
  orders_a86775a3,
  additionalClaimDocuments_64d9d05d,
  dropoffs_43ce26e5,
  components_baad9e43,
  confirmationDisplay_9073d467,
  exchangeConversion_31b5d151,
  returns_0ccce345,
  cart_921edd15,
  media_9a207fdd,
  productOptions_176a883a,
  productConfigurator_b4bd8934,
  variantPicker_c8533f48,
  components_c8f7dbfc,
  hooks_d951004c,
  cart_fe19976f,
  addExchangeItem_0aa6c2ac,
  chooseCompensationMethod_f6a99f24,
  claimDocumentsReturn_a4b2393e,
  flowInput_5efb1ad4,
  flowReturn_eb195764,
  flow_11080d18,
  itemDetails_131c1845,
  login_38c568be,
  merchantFlow_dee61aed,
  packagePickup_30db431b,
  review_7d61328e,
  selectItems_b3b7a91e,
  shipmentMethod_3d0a4272,
  shopNow_7cf8081c,
  withdrawalReview_c96d1332,
  submission_b88e3dfc,
  actionAuthorize_4abc4675,
  csat_d29dc12e,
  customization_1da3bcec,
  list_8fd75d5d,
  login_16c6e00f,
  merchantOverrides_a2188522,
  sharedComponents_522eec4e,
  util_d059057b,
  components_e16f89f8,
  hooks_631c1a95,
  screens_5c95bcfc,
  register_7b902d88,
  thirdPartyWarranty_def7b5df,
  policies_2263052d,
  warranties_45249157,
);
